module.exports = __webpack_public_path__ + "static/img/davidgraujr_circle150.3689eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/davidgraujr_circle150.png
// module id = O6Gn
// module chunks = 0